import {createFileRoute} from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/home/statements/$id')({
  staticData: {crumbKey: 'navigation.statement'},
});
